export default "__VITE_ASSET__CVF5WMcn__"